/**
 * @generated SignedSource<<0d08d4a0bf6275564398340c933231e7>>
 * @relayHash 6d08d022528eb28ac16670279f7520c4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 99368df20fb2d52557593c6b23a5d8516437ab3c7c0234586059c0cb351905c2

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBoardQuery } from './src_jiraBoardQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBoardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "99368df20fb2d52557593c6b23a5d8516437ab3c7c0234586059c0cb351905c2",
    "metadata": {},
    "name": "src_jiraBoardQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
